// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"56760cec","359":"b41d2cc2"}[chunkId] + ".chunk.js";
};